import getCurrentMainDomain from './getCurrentMainDomain'
import isInSalesPoint from 'App/helpers/misc/isInSalesPoint'

export default function isEnviromentDomain() {
  return !!getCurrentMainDomain() && !isInSalesPoint()
}
